export enum LoadState {
    Initial = 'Initial',
    Loading = 'Loading',
    Success = 'Success',
    Error = 'Error',
};